import React from "react";
import { Form } from "react-bootstrap";

const InputText = (props) => {
  const thisChange = (e) => {
    let vl = e.target.value;
    if (props.inputType === "number") {
      if (!isNaN(vl)) {
        props.myOnChange(vl);
      }
    } else {
      props.myOnChange(vl.charAt(0).toUpperCase() + vl.slice(1));
    }
  };
  return (
    <Form.Group className="mb-3" controlId={props.myName}>
      <Form.Label style={{ color: props.labelcolor }}>
        {props.label}
        {props.Compulsory && (
          <sup style={{ color: "Red", fontSize: "13px" }}>*</sup>
        )}
      </Form.Label>
      <Form.Control
        type="text"
        value={props.myVal ? props.myVal : ""}
        required={props.required}
        ref={props.myRef}
        onBlur={props.getAction}
        onChange={thisChange}
        name={props.myName}
        readOnly={props.readonly}
        placeholder={props.placeholder}
        style={
          props.error
            ? { backgroundColor: "Red" }
            : {
                backgroundColor: "White",
                boxShadow: "5px 5px #b1b1b1",
              }
        }
      />
    </Form.Group>
  );
};

export default InputText;
